import React, { useCallback, useState } from 'react'
import { Typography } from '@mui/material'
import { deleteUser, deleteTenantUser } from '../api'
import { translate } from '../i18n'
import { DialogPopup } from '../components'
import { UserDeletePopupProps } from './UserDeletePopup.types'

export default function UserDeletePopup({
    tenantId,
    user,
    onCompleted,
    onCancelled,
    onError,
}: UserDeletePopupProps) {
    const [submitting, setSubmitting] = useState<boolean>(false)

    const deletePromise = useCallback((): Promise<void> => {
        if (tenantId) {
            return deleteTenantUser(tenantId, user.id)
        }
        return deleteUser(user.id)
    }, [user, tenantId])

    const onConfirm = useCallback(() => {
        setSubmitting(true)
        deletePromise()
            .then(() => {
                setSubmitting(false)
                onCompleted()
            })
            .catch((error) => {
                setSubmitting(false)
                onError(error.message)
            })
    }, [deletePromise, onCompleted, onError])

    return (
        <DialogPopup
            open
            variant="error"
            title={translate('users.delete.title') as string}
            disableEscapeKeyDown={submitting}
            disableBackdropClick={submitting}
            disable={submitting}
            closeText={translate('buttons.cancel') as string}
            onClose={onCancelled}
            fullWidth
            maxWidth="sm"
            button={{
                text: translate('buttons.delete'),
                onClick: onConfirm,
                disabled: submitting,
            }}
        >
            <Typography variant="body2">
                {translate('users.delete.description', {
                    first_name: user.first_name,
                })}
            </Typography>
        </DialogPopup>
    )
}
